import { render, staticRenderFns } from "./upper-bank-info.vue?vue&type=template&id=6bd9abc4&scoped=true&"
import script from "./upper-bank-info.vue?vue&type=script&lang=js&"
export * from "./upper-bank-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9abc4",
  null
  
)

export default component.exports